import PropTypes from 'prop-types'
import styles from './Placeholder.module.scss'
import colors from '../../../assets/styles/globals.scss'
import SubmitButton from '../../common/buttons/SubmitButton'
import { pluralize } from '../../../utility/helperFunctions'
import { ReactComponent as LeaderboardIcon } from '../../../assets/images/common/icons/leaderboard-icon.svg'

const Placeholder = ({ eventInProgress, logScores, savedScoresCount, isDraft }) => (
  <div className={styles.placeholderWrapper}>
    <div className={styles.placeholderContainer}>
      <LeaderboardIcon fill={eventInProgress ? colors.primaryOrange : colors.placeholderGray} className='mb-3'/>
      {isDraft
        ? <>
          <p className={styles.title}>No Leaderboard</p>
          <p className={styles.description}>
            This is a draft state. Leaderboard is not available until you publish this event series.
          </p>
        </>
        : eventInProgress
          ? <>
            <p className={styles.title}>{'Scoring "In-Progress"'}</p>

            <p className={styles.description}>
              {`You have ${savedScoresCount} ${pluralize('score', savedScoresCount)} logged so far.
                Continue logging your scores and complete the event to see the leaderboard.`}
            </p>

            <div className={styles.logScoresButton}>
              <SubmitButton
                onClick={logScores}
                buttonMessage='Continue Logging'
                buttonColor='orange-button'
              />
            </div>
          </>
          : <>
            <p className={styles.title}>No Leaderboard</p>

            <p className={styles.description}>
              Click below to begin logging scores for this event.  You can always start logging and save your progress as you go.
            </p>

            <div className={styles.logScoresButton}>
              <SubmitButton
                onClick={logScores}
                buttonMessage='Log Scores'
                buttonColor='orange-button'
              />
            </div>
          </>
      }
    </div>
  </div>
)

Placeholder.propTypes = {
  eventInProgress: PropTypes.bool,
  logScores: PropTypes.func.isRequired,
  savedScoresCount: PropTypes.number,
  isDraft: PropTypes.bool,
}

export default Placeholder
